import { render } from "./AboutServiceWorkersSection.vue?vue&type=template&id=77379db1"
import script from "./AboutServiceWorkersSection.vue?vue&type=script&lang=js"
export * from "./AboutServiceWorkersSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__